import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import ImgDestaque from 'assets/img/destaque-ilustracao.png';
import { TasksPendingApprovalParticipantsModal } from 'components/tasks-pending-approval-participants-modal';
import Button from 'components/ui/button';
import { useAuth } from 'context/AuthContext';
import { removeStorageItem } from 'utils/storage';

import { canRegisterRealizacao, isLadderManager } from '../home-reads';
import { usePendingParticipantApprovals } from '../usePendingParticipantApprovals';
import { ProgramSection } from './program-section';

/**
 * Realizações Destaque com um ciclo fechado selecionado: só os atalhos de acompanhamento, sem
 * agenda, prazo nem cadastro. Quem não cadastra nem aprecia não vê a seção.
 */
export function TaskCyclesClosed() {
  const navigate = useNavigate();
  const { userInfo } = useAuth();
  const tasksPendingApproval = usePendingParticipantApprovals(userInfo);

  // A Home sempre desfaz a escolha de lateralidade: sem isso o gestor entraria na apreciação
  // como o colega que substituiu na visita anterior (FECH-10).
  useEffect(() => {
    removeStorageItem('manager_lateralidade');
  }, []);

  const isManager = isLadderManager(userInfo);
  const showSection = isManager || canRegisterRealizacao(userInfo);

  return (
    <>
      {showSection && (
        <ProgramSection
          program="destaque"
          name="Realizações Destaque"
          description={<p>Visualize suas Realizações Destaque e acompanhe os status de apreciação.</p>}
          // D3: 150px não tem degrau no Tailwind.
          illustration={<img src={ImgDestaque} alt="" className="block w-[150px]" />}
          actions={
            isManager ? (
              <>
                <Button variant="solido-destaque" size="sm" onClick={() => navigate('/minha-equipe/validar-apreciar-realizacao')}>
                  Acompanhar realizações
                </Button>
                <Button variant="texto" size="sm" onClick={() => navigate('/realizacao-destaque')}>
                  Acompanhar minhas realizações
                </Button>
              </>
            ) : (
              <Button variant="solido-destaque" size="sm" onClick={() => navigate('/realizacao-destaque')}>
                Acompanhar realizações
              </Button>
            )
          }
        />
      )}

      <TasksPendingApprovalParticipantsModal tasks={tasksPendingApproval} />
    </>
  );
}
